import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { key: 0 }

import Navbar from "@/components/Navbar.vue";
import HeroSection from "@/components/HeroSection.vue";
import AboutUs from "@/components/AboutUs.vue";
import ContactLocation from "@/components/ContactLocation.vue";
import PreInscription from "@/components/PreInscription.vue";
import Footer from "@/components/Footer.vue";
import LegalNotice from "@/components/LegalNotice.vue";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// We import all components for our page
const showLegalNotice = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!showLegalNotice.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Navbar),
          _createElementVNode("main", null, [
            _createVNode(HeroSection),
            _createVNode(AboutUs, { id: "qui-sommes-nous" }),
            _createVNode(ContactLocation, { id: "ou-sommes-nous" }),
            _createVNode(PreInscription, { id: "formulaire" })
          ]),
          _createVNode(Footer, {
            onShowLegal: _cache[0] || (_cache[0] = ($event: any) => (showLegalNotice.value = true))
          })
        ]))
      : _createCommentVNode("", true),
    (showLegalNotice.value)
      ? (_openBlock(), _createBlock(LegalNotice, {
          key: 1,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (showLegalNotice.value = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})